<template>

    <div id="right-panel" class="right-panel fContainer">

    <SellHeader></SellHeader>


    <div class="content mt-3 fColumn">
        <div class="animated fadeIn fColumn">
            <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
            <form action="/" method="post" id="form" class="userForm ajaxForm     fColumn">
                <div class="card     fColumn ">
                    <div class="card-header     fHead">
                        <strong>{{$t('buyer.title')}}</strong>
                        <div class="float-right">
                            <a data-template="buyer" data-clear="true" data-clearTarget="true" class="linkToTemplate" href="#">
                                <button type="button" class="btn btn-primary btn-smX " v-on:click="newBuyer()">
                                    <i class="fa fa-star"></i> {{$t('buyer.new')}}
                                </button>
                            </a>
                        </div>
                    </div>
                    <div class="    fContent">
                        <div class="card-body card-block ">
                            <form action="" method="post" class="">

                                <div class="hiddenSzb">
                                    <input type="text" name="del">
                                    <input type="text" id="id" name="id" class="form-control id"
                                           value="">
                                </div>
                                <div class="row form-group">
                                    <div class="col-12">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="select" class=" form-control-label">{{$t('buyer.gender')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <select name="gender" id="select" class="form-control" v-model="data.gender">
                                            <option value="0">{{$t('global.notset')}}</option>
                                            <option value="1">{{$t('global.male')}}</option>
                                            <option value="2">{{$t('global.female')}}</option>
                                        </select>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="pre_name" class=" form-control-label">{{$t('buyer.pre_name')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="pre_name"  name="data.pre_name" v-model="data.pre_name" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.pre_name')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.pre_name')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>

                                <div v-if="lang!=='hu'">
                                    <div class="row form-group">
                                        <div class="col col-6 extensionLine">
                                            <label for="first_nameE" class=" form-control-label">{{$t('buyer.first_name')}}</label>
                                        </div>
                                        <div class="col col-6">
                                            <InputText id="first_nameE"  name="data.first_name" v-model="data.first_name" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('buyer.first_name')"
                                                       placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.first_name')"/>
                                            <small class="unit form-text text-muted d-none"></small>
                                        </div>
                                    </div>
                                    <div class="nameInOne">
                                        <div class="row form-group">
                                            <div class="col col-6 extensionLine">
                                                <label for="last_nameE" class=" form-control-label">{{$t('buyer.last_name')}}</label>
                                            </div>
                                            <div class="col col-6">
                                                <InputText id="last_nameE"  name="data.last_name" v-model="data.last_name" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.last_name')"
                                                           placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.last_name')"/>
                                                <small class="unit form-text text-muted d-none"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="lang==='hu'">
                                    <div class="nameInOne">
                                        <div class="row form-group">
                                            <div class="col col-6 extensionLine">
                                                <label for="last_nameH" class=" form-control-label">{{$t('buyer.last_name')}}</label>
                                            </div>
                                            <div class="col col-6">
                                                <InputText id="last_nameH"  name="data.last_name" v-model="data.last_name" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.last_name')"
                                                           placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.last_name')"/>
                                                <small class="unit form-text text-muted d-none"></small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col col-6 extensionLine">
                                            <label for="first_nameH" class=" form-control-label">{{$t('buyer.first_name')}}</label>
                                        </div>
                                        <div class="col col-6">
                                            <InputText id="first_nameH"  name="data.first_name" v-model="data.first_name" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('buyer.first_name')"
                                                       placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.first_name')"/>
                                            <small class="unit form-text text-muted d-none"></small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="born_year" class=" form-control-label">{{$t('buyer.born')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="born_year"  name="data.born_year" v-model="data.born_year" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.born')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.born_year')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="data.zip_code" class=" form-control-label">{{$t('buyer.zipCode')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="data.zip_code"  name="data.zip_code" v-model="data.zip_code" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('buyer.zipCode')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.zip_code')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="email" class=" form-control-label">{{$t('buyer.email')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="email"  name="data.email" v-model="data.email" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('buyer.email')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.email')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="phone" class=" form-control-label">{{$t('buyer.phone')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="phone"  name="data.phone" v-model="data.phone" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.phone')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.phone')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="address" class=" form-control-label">{{$t('buyer.address')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="address"  name="data.address" v-model="data.address" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.address')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.address')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="company" class=" form-control-label">{{$t('buyer.company')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="company"  name="data.company" v-model="data.company" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.company')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.company')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="data.sid" class=" form-control-label">{{$t('buyer.sid')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="data.sid"  name="data.sid" v-model="data.sid" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('buyer.sid')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.sid')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="data.discount" class=" form-control-label">{{$t('buyer.discount')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="data.discount"  name="data.discount" v-model="data.discount" v-validate="'required|integer|between:0,100'" hasToKeyboard="auto" value="" :title="$t('buyer.discount')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.discount')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-6 extensionLine">
                                        <label for="text" class=" form-control-label">{{$t('buyer.text')}}</label>
                                    </div>
                                    <div class="col col-6">
                                        <InputText id="text"  name="data.text" v-model="data.text" v-validate="" hasToKeyboard="auto" value="" :title="$t('buyer.text')"
                                                   placeholder="..." dataLayout="t" className="form-control mandatory" :hasError="errors.has('data.text')"/>
                                        <small class="unit form-text text-muted d-none"></small>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="card-footer text-center fFix">
                        <button v-on:click="save()" type="button" class="btn btn-success btn-lg">
                            <i class="fa fa-dot-circle-o"></i> {{$t('buyer.save')}}
                        </button>
                    </div>
                </div>
            </form>
        </div><!-- .animated -->
    </div><!-- .content -->
</div>

</template>


<script>
    import LngChooser from '@/components/LngChooser.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Helper from '@/helper/Helper';
    import SellHeader from "../components/SellHeader";
    import InputText from '@/components/InputText.vue';
    import i18n from '@/i18n';
//    import SyncHandler from '@/sync/syncHandler';
    import Api from '@/api/Api';

    export default {
        name: 'Buyer',
        data() {
            return {
                data: {
                    id: "",
                    gender: "",
                    pre_name: "",
                    first_name: "",
                    last_name: "",
                    born: "",
                    zipCode: "",
                    email: "",
                    phone: "",
                    address: "",
                    company: "",
                    sid: "",
                    discount: "",
                },
                dataDefault: {
                    id: "",
                    gender: "",
                    pre_name: "",
                    first_name: "",
                    last_name: "",
                    born: "",
                    zipCode: "",
                    email: "",
                    phone: "",
                    address: "",
                    company: "",
                    sid: "",
                    discount: "",
                }
                , lang: "en"
                , AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    delay: 5000,
                }
            };
        },
        watch: {
            'localStorage.lang': function (newLang, oldLang) {
                const modul = this;
                modul.lang = newLang;
            }
            ,'data.sid': function (newdata, olddata) {
                const modul = this;
                if(modul.timer){
                    clearTimeout(modul.timer);
                }
                modul.timer=setTimeout(function () {
                    if (newdata&& newdata!==olddata) {
                        modul.data.sid = modul.data.sid.replace(/ö/g, '0');
                    }
                },300);
            }
        },
        mounted() {
            const modul = this;
            console.log(this.$route.name + " mounded");
            modul.roles = [3, 4, 5, 6, 7, 8, 9, 10];
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          if (!Helper.checkRoles(modul.roles, role)) {
                modul.$router.push({name: "login"})
            }
            modul.$eventBus.$on('globalSetLang', this.globalSetLangEventHandler);
            modul.$eventBus.$on('globalReadBuyerSid', this.globalReadBuyerSidEventHandler);
        },
        beforeDestroy() {
            const modul = this;
            modul.$eventBus.$off('globalSetLang');
            modul.$eventBus.$off('globalReadBuyerSid');
        },
        methods: {
            globalReadBuyerSidEventHandler(sid){
                const modul = this;
                modul.data.sid = sid;
            },
            newBuyer(){
                const modul = this;
                modul.data = Object.assign({},modul.dataDefault);
            },
            globalSetLangEventHandler(lang){
                const modul = this;
                modul.lang = lang;
            },
            save(){
                const modul = this;
                modul.$validator.validateAll().then((result) => {
                    if (result) {
                        const data = Helper.makeFilteredObjectByKeys(modul.data, Object.keys(modul.dataDefault));
                        this.getBuyerBySid(function (err, res) {
                            let data = modul.data;
                            if (!data.id) {
                                data.id = null;
                            }
                            delete data.del;
                            data['sync_mdt'] = Helper.getNewUTCDateTime(); //new Date(); //model.createDateAsUTC(new Date());
                            if (res && res.length > 0) {
                                // Ha van ilyen buyer
                                // csekk, hogy a két id egyezik-e ha igen, ment7ő, mert update
                                if (Number(res[0].id) === Number(data.id)) {
                                    const cb = function (err, res) {
                                        modul.AlertInPage.msg = "buyer.textsucces";
                                        modul.AlertInPage.type = "success";
                                        setTimeout(function (e) {
                                            modul.AlertInPage.msg = "";
                                            modul.$router.push({name: "sellinone"})
                                        }, Number(1000));
                                        setTimeout(function () {
//                                            SyncHandler.handle({job: 'doBuyer'});
                                        },0);
                                    };

                                  Api.saveBuyer({data:data}).then(function (e) {
                                    if (e && e.result === true) {
                                      console.log(e)
                                      cb(null,e.data);
                                    }
                                  },function (err) {
                                    console.log(err)
                                    cb(err,null);
                                  });
//                                    window.db.update(
//                                        function (err, res) {
//                                            cb(err, window.db.convertResToArray(err, res))
//                                        }
//                                        , "buyer", data, "where id=" + Number(data.id));
                                } else {
                                    modul.AlertInPage.msg = "buyer.texterror";
                                    modul.AlertInPage.type = "danger";
                                    setTimeout(function (e) {
                                        modul.AlertInPage.msg = "";
                                    }, Number(5000));
                                }
                            } else {
                                const cb = function (err, res) {
                                    modul.AlertInPage.msg = "buyer.textsucces";
                                    modul.AlertInPage.type = "success";
                                    setTimeout(function (e) {
                                        modul.AlertInPage.msg = "";
                                        modul.$router.push({name: "sellinone"})
                                    }, Number(1000));
                                };
                                // Ha nincs ilyen buyer
                                data['create_dt'] = Helper.getNewUTCDateTime();
                              Api.saveBuyer({data:data}).then(function (e) {
                                if (e && e.result === true) {
                                  console.log(e)
                                  cb(null,e.data);
                                }
                              },function (err) {
                                console.log(err)
                                cb(err,null);
                              });
//                                window.db.pinsert(
//                                    function (err, res) {
//                                        cb(err, window.db.convertResToArray(err, res))
//                                    }
//                                    , "buyer", data);
                            }
                        }, data.sid);
                    } else {
                        // form validate error
                        modul.AlertInPage.msg = "global.saveError";
                        modul.AlertInPage.type = "danger";
                        setTimeout(function (e) {
                            modul.AlertInPage.msg = "";
                        }, Number(5000));
                    }
                });
            },
            getBuyerBySid: function (cb, sid) {
              Api.getBuyerBySid({id:sid}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null,e.data);
                }
              },function (err) {
                console.log(err)
                cb(err,null);
              });

//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "buyer", "*", "sid=" + window.db.quote(sid) + " AND (`deleted` = 0 OR `deleted` = '0')");
            },
        },
        components: {
            SellHeader,
            InputText,
            LngChooser,
            AlertInPage,
        },
    };
</script>

